const { getFieldOptions, createModel, createCollection } = require("../utils");
const { products } = require("./product");
const { Joi, modelOptions } = require("../joi");

exports.parcel = createModel((prefix, options) => ({
  products: products(`${prefix}.products`, options).required(),
  parcelId: Joi.string()
    .example("0fb22838-7ec0-4d36-9f5b-c273b6bf0d73")
    .options(getFieldOptions(options)),
}));

exports.parcels = createCollection(
  (prefix, { parcelModel = exports.parcel, ...options } = {}) =>
    Joi.array()
      .items(parcelModel(`${prefix}.parcels`, options))
      .options(modelOptions)
);
